module.exports = __webpack_public_path__ + "fonts/Raleway-Bold.eb5477cd.ttf";